<template>
  <div>
    <div class="wrappersAA">
      <div class="homesAA">
        <div class="homes-swipeAA">
          <van-swipe :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(v, i) in swipeList" :key="i">
              <!-- <van-image fit="contain" src="https://img.yzcdn.cn/vant/cat.jpeg" @click="goto(v)" /> -->
              <van-image fit="contain" :src="v.image_url" @click="goto(v)" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <van-search v-model="searchValue" placeholder="请输入搜索关键词" show-action @search="onSearchJ" class="mySearchsAA"
          enterkeyhint="search">
          <div slot="action" @click="onSearchJ"></div>
        </van-search>
        <div class="recommendAA">
          <div v-for="info of recommendList" :key="info.id" class="rwrapperAA" @click="() => openVideo(info)">
            <img :src="info.bg" />
            <!-- <img src="@/assets/logo.png" /> -->
            <div class="rtitleAA">{{ info.title }}</div>
            <div class="infoAA">
              <div>{{ `${info.file_total}节/${Number(info.duration / 60).toFixed(0)}分钟` }}</div>
            </div>
          </div>
        </div>
      </div>
      <yq-tabbar :active=0></yq-tabbar>

    </div>
  </div>
</template>
<script>
import yqTabbar from '@/components/yq-tabbar.vue';
import FloatButton from './floatbutton.vue';
import { getInfo, bannerGet, getDetail, loginApi, userInfo } from '@/api/shopapi';
var moment = require('moment');
export default {
  name: 'School',
  components: {
    yqTabbar,
    FloatButton
  },
  data() {
    return {
      loading: false,
      recommend: {},
      searchValue: '',
      swipeList: [],
      recommendList: [],
    }
  },
  async mounted() {
    if (this.$route.query.phone) {
      await loginApi(this.$route.query).then(res => {
        if (res.code !== '000') {
          this.$toast.fail({
            duration: 2000, // 持续展示 toast
            forbidClick: true,
            message: res.message,
            onClose: ()=>{
              // window.close()
            }
          })
        }
        localStorage.setItem('a-token', res.data)
        userInfo().then(res => {
          localStorage.setItem('info', JSON.stringify(res.data))
        })
      })
    }
    await this.initStudyList()
    await this.getBanner()

  },
  methods: {
    // 暂时不用
    async getBanner () {
      const blist = await bannerGet({ type: null })
      try {
        this.swipeList = blist.data
      } catch (e) {
        console.log(e)
      }
    },
    async initStudyList() {
      const { data, code, message } = await getInfo({
        page_no: 0,
        page_size: 100000
      })
      if (code === '000') {
        this.recommendList = data.data_list
        this.loading = false
      } else {
        this.$toast.fail({
          duration: 2000, // 持续展示 toast
          forbidClick: true,
          message: message,
          onClose: ()=>{
            // window.close()
          }
        })
      }
      
    },
    async goto(v) {
      if (1 === 1) {
        return
      }
      if (v.url) {
        window.location.href = v.url
      } else {
        const { data } = await getDetail({ info_id: v.info_id })
        let info = data
        console.log('infoXX', info)

        // console.log('res',res)
        // const x = res.data.data_list
        this.$router.push({ name: "PlayVideo", params: info })
      }
    },
    openVideo(info) {
      this.$router.push({ name: "PlayVideo", params: info });
    },
    onSearchJ() {
      this.$router.push({
        name: "schoolSearch", params: {
          category_id: null,
          stitle: this.searchValue,
          page_no: 0,
          page_size: 100000
        }
      });
    },
    async onSearch() {
      if (this.loading) {
        return
      }
      try {
        this.loading = true
        let rec = {}
        if (this.searchValue === '' && this.recommend) {
          rec = {
            category_id: this.recommend.category_id,
            page_no: 0,
            page_size: 100000
          }
        } else {
          rec = {
            category_id: null,
            title: this.searchValue,
            page_no: 0,
            page_size: 100000
          }
        }
        const { data } = await getInfo(rec)
        this.recommendList = []
        this.$nextTick(() => {
          this.recommendList = data.data_list.map(m => {
            m.bg = m.bg || '../../../static/img/bg/ept.jpg'
            return m
          })
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    isDiscount(x) {
      if (x.discount_time) {
        if (!moment().isBefore(x.discount_time)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }

    }
  }
}
</script>
<style>
.homesAA {
  background: transparent;
  width: 100%;
  display: flex;
  overflow-y: scroll;
  /* height: calc(100vh - 46px); */
  padding-bottom: 46px;
  flex-direction: column;
}

.homes-swipeAA {
  box-sizing: border-box;
  padding: 46px 10px 10px 10px;
}

.mySearchsAA {
  position: absolute;
  top: 0;
  width: 90%;
  background: transparent !important;
  left: 10%;
  font-size: 12px;
  z-index: 101
}

.mySearchsAA .van-cell {
  padding: 0px !important;
}

.mySearchsAA .van-search__content {
  border: 1px solid red;
  border-radius: 25px;
}

.wrappersAA {
  position: relative;
  display: block;
  background-color: #f3f2f2;
  width: 100%;
  height: calc(100vh - 96px);
  overflow: auto;
}

.midItemAA {
  text-align: center;
  padding: 6px 0px;
  width: calc((100% - 20px) / 5);
}

.recommendAA {
  flex: 1;
  margin: 0px 10px 0px 10px;
  width: calc(100% - 20px);
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
}

.rwrapperAA {
  display: flex;
  flex-direction: column;
  width: calc(50% - 16px);
  height: 168px;
  margin-bottom: 8px;
  background: white;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.rwrapperAA img {
  width: 100%;
  height: auto;
  padding: 0 !important;
  margin: 0 !important;
  max-height: 104px;
  /* border: 1px solid rgb(119, 119, 119); */
}

.recommendAA :nth-child(odd) {
  margin-right: 5px;
}

.recommendAA :nth-child(even) {
  margin-left: 5px;
}

#scrollBody {
  padding: 0px 10px 10px 10px;
  width: auto;
  overflow-x: hidden;
  overflow-y: hidden
}

.rtitleAA {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  /* 显示两行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px !important;
  margin: 0 !important;
  font-size: 0.33rem;
  line-height: 1.1;
  font-weight: 400;
  height: 1rem;
}

.infoAA {
  display: flex;
  justify-content: space-between;
  padding: 4px !important;
  margin: 0 !important;
  font-size: 0.3rem;
  line-height: 1.2;
  font-weight: lighter;
}

.infoAA>div {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
